import { render, staticRenderFns } from "./clients-assign-search.vue?vue&type=template&id=11db1c60&"
import script from "./clients-assign-search.vue?vue&type=script&lang=js&"
export * from "./clients-assign-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports